// extracted by mini-css-extract-plugin
module.exports = {"arrive":"MessageRow_arrive__ncMNP","arriveGroup":"MessageRow_arriveGroup__ja7_d"};